import createReactClass from "create-react-class";
import moment from "moment";
import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { AutoSizer, Column, Table } from "react-virtualized";
import { ServerActions } from "../actions/serverActions";
import { SubdivisionActions } from "../actions/subdivisionActions";
import { TabActions } from "../actions/tabActions";
import Constants from "../constants/constants";
import { tabsStore } from "../stores/tabs";
import { formValidation } from "../util/formValidation";
import { ContentBox } from "./admin/ContentBox";

import "../css/adminScreen.css";

var dataForIssuedTab;
var ifDataModified = false;

function open(props, rowData) {
  var changedSub = false;
  if (
    props.selectedSub === 0 ||
    rowData.subdivision.trim() !== props.selectedSub.trim()
  ) {
    //if they click on a request/restriction that is in a different sub, change to that sub
    SubdivisionActions.selectChanged(rowData.subdivision);
    changedSub = true;
  }

  ServerActions.openRequestOrRestriction(rowData.requestId, changedSub);
}

function openFormC(rowData) {
  ServerActions.openRequestOrRestriction(rowData.requestId, false, false);
}

function openTCM(rowData) {
  ServerActions.openRequestOrRestriction(rowData.requestId, false, false);
}
function openRequest(props, rowData) {
  var changedSub = false;
  if (
    props.selectedSub === 0 ||
    rowData.subdivision.trim() !== props.selectedSub.trim()
  ) {
    //if they click on a request/restriction that is in a different sub, change to that sub
    SubdivisionActions.selectChanged(rowData.subdivision);
    changedSub = true;
  }

  if (rowData.status === "request" && rowData.controlNumber !== 0) {
    //This is a request to modify
    ServerActions.openRequestToModify(rowData.requestId, changedSub);
  } else {
    ServerActions.openRequestOrRestriction(rowData.requestId, changedSub);
  }
}

function getStateFromStores() {
  return {
    isLoading: false,
    disableHeader: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    recentSortBy: tabsStore.getRecentListSortBy(),
    recentSortDirection: tabsStore.getRecentListSortDirection(),
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
    previousSub: "",
    previousTab: "true",
  };
}

export const RestrictionList = createReactClass({
  //console.log("++++++++++++++++Inside Create Class Method.");
  getInitialState: function () {
    return getStateFromStores();
  },

  _getRowHeight({ index }) {
    const { list } = this.context;

    return this._getDatum(list, index).size;
  },

  componentDidMount: function () {
    tabsStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    tabsStore.unsubscribe(this._onChange);
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  _updateUseDynamicRowHeight(value) {
    this.setState({
      useDynamicRowHeight: value,
    });
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },
  _noRowsRenderer() {
    var noRow;

    if (this.props.loading) {
      noRow = "Loading ...";
    } else if (this.props.gridType === "recentIssued") {
      noRow =
        "No restrictions issued/voided in past " +
        Constants.recentHours +
        " hours";
    } else if (this.props.messages.length !== 0) {
      noRow = this.props.messages[0].message;
    } else {
      noRow = "No rows found";
    }
    return <div className="issuedNoRows">{noRow}</div>;
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },

  formatValue({ cellData, dataKey, rowData }) {
    if (dataKey === "workStartMp") {
      return (
        formatMp(cellData) +
        (rowData.workStartMpSuffix ? rowData.workStartMpSuffix : "")
      );
    } else if (dataKey === "subdivision") {
      if (rowData.subdivision === "MULTI") {
        return renderMultiSubHover(rowData.subdivisions);
      } else {
        return rowData.subdivision;
      }
    } else if (dataKey === "workEndMp") {
      return (
        formatMp(cellData) +
        (rowData.workEndMpSuffix ? rowData.workEndMpSuffix : "")
      );
    } else if (dataKey === "syncId") {
      return "GR" + rowData.syncId;
    } else if (dataKey === "foremanName") {
      return rowData.foremanName
        ? rowData.foremanName.toString().toUpperCase()
        : "";
    } else if (dataKey === "passengerSpeed" || dataKey === "freightSpeed") {
      return cellData > 0 ? cellData : "NA";
    } else if (dataKey === "tracks") {
      return renderTracks(rowData.tracks);
    } else if (dataKey === "effectiveTime") {
      if (rowData.effectiveTime) {
        if (moment(rowData.effectiveTime).isSame(moment(rowData.issueTime))) {
          return "";
        }
        else {
          return getDt(rowData.effectiveTime) + rowData.restrictionTimeZone
        }
      }
      else {
        return "";
      }
    } else if (dataKey === "workStartDate") {
      return rowData.workStartDate
        ? moment(rowData.workStartDate).format("ddd HH:mm")+rowData.restrictionTimeZone+" "+moment(rowData.workStartDate).format("MM/DD/YY")
        : "";
    } else if (dataKey === "workEndDate") {
      return rowData.workEndDate
        ? moment(rowData.workEndDate).format("ddd HH:mm")+rowData.restrictionTimeZone+" "+moment(rowData.workEndDate).format("MM/DD/YY")
        : "";
    } else if (dataKey === "issueTime") {
      return rowData.issueTime
        ? getDt(rowData.issueTime) + rowData.restrictionTimeZone
        : "";
    } else if (dataKey === "recentIssueTime") {
      return rowData.issueTime
        ? getDtRecent(rowData.issueTime) + rowData.restrictionTimeZone
        : "";
    } else if (dataKey === "estimatedRemovalDate") {
      if (rowData.permanentIndicator === "Y") {
        return "Permanent";
      } else {
        return rowData.estRemovalDate
          ? moment(rowData.estRemovalDate).format("MM/DD/YY")
          : "";
      }
    } else if (dataKey === "formCFrom") {
      if (rowData.subdivision === "MULTI" || rowData.subdivision === "ALL") {
        return "";
      } else {
        if (
          rowData.fromLocation !== null &&
          rowData.fromLocation !== undefined &&
          rowData.fromLocation !== ""
        ) {
          return rowData.fromLocation;
        } else {
          return (
            formatMp(rowData.workStartMp) +
            (rowData.workStartMpSuffix ? rowData.workStartMpSuffix : "")
          );
        }
      }
    } else if (dataKey === "TCMFrom") {
      if (
        rowData.fromLocation !== null &&
        rowData.fromLocation !== undefined &&
        rowData.fromLocation !== ""
      ) {
        return rowData.fromLocation;
      } else {
        return (
          formatMp(rowData.workStartMp) +
          (rowData.workStartMpSuffix ? rowData.workStartMpSuffix : "")
        );
      }
    } else if (dataKey === "formCTo") {
      if (rowData.subdivision === "MULTI" || rowData.subdivision === "ALL") {
        return "";
      } else {
        if (
          rowData.toLocation !== null &&
          rowData.fromLocation !== undefined &&
          rowData.toLocation !== ""
        ) {
          return rowData.toLocation;
        } else {
          return (
            formatMp(rowData.workEndMp) +
            (rowData.workEndMpSuffix ? rowData.workEndMpSuffix : "")
          );
        }
      }
    } else if (dataKey === "TCMTo") {
      if (rowData.subdivision === "MULTI" || rowData.subdivision === "ALL") {
        return "";
      } else {
        if (
          rowData.toLocation !== null &&
          rowData.fromLocation !== undefined &&
          rowData.toLocation !== ""
        ) {
          return rowData.toLocation;
        } else {
          return (
            formatMp(rowData.workEndMp) +
            (rowData.workEndMpSuffix ? rowData.workEndMpSuffix : "")
          );
        }
      }
    } else if (dataKey === "formCComments") {
      return renderDataWithPopover(rowData.comments);
    } else if (dataKey === "TCMComments") {
      return renderTCMDataWithPopover(rowData.comments);
    }
  },
  //sort the records in issue table
  _sort({ sortBy, sortDirection }) {
    window.searchSortActive = true;
    const comparer = (a, b) => {
      ifDataModified = true;
      if (sortBy === "tracks") {
        a = a["tracks"].length > 1 ? "*Multiple*" : a["tracks"][0];
        b = b["tracks"].length > 1 ? "*Multiple*" : b["tracks"][0];
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else if (sortBy === "effectiveTime") {
        a = a.effectiveTime
          ? moment(a.effectiveTime).format("MM/DD/YY HH:mm") +
            a.effectiveTimezone
          : "";
        b = b.effectiveTime
          ? moment(b.effectiveTime).format("MM/DD/YY HH:mm") +
            b.effectiveTimezone
          : "";
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else if (sortBy === "foremanName") {
        a = a["foremanName"].toString().toUpperCase();
        b = b["foremanName"].toString().toUpperCase();
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else {
        if (sortDirection === "ASC") {
          return a[sortBy] > b[sortBy] ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      }
    };
    var rows;
    if (ifDataModified) {
      rows = this.state.filteredData.sort(comparer);
    } else {
      rows = this.props.data.sort(comparer);
    }
    dataForIssuedTab = rows;
    this.setState({ filteredData: dataForIssuedTab });
    this.setState({ sortBy, sortDirection });
  },

  _recentSort({ sortBy, sortDirection }) {
    var rows;
    if (ifDataModified) {
      rows = recentSort(this.state.filteredData, sortBy, sortDirection);
    } else {
      rows = recentSort(this.props.data, sortBy, sortDirection);
    }
    dataForIssuedTab = rows;
    this.setState({ filteredData: dataForIssuedTab });
    TabActions.recentSortChanged(sortBy, sortDirection);
  },

  //Filter records for the issue Table
  _filterRecordsOfTheTable(value) {
    var dataSet = this.props.data;
    ifDataModified = true;

    if (this.props.gridType === "recentIssued") {
      //Special sort for the recent tab
      dataSet = dataSet.filter(function (item) {
        var recentIssueTime = item.issueTime
          ? moment(item.issueTime).format("MM/DD/YY HH:mm")
          : "";

        let searchDecVal = value.trim().split(".");

        if (searchDecVal.length === 2) {
          if (/^0*$/.test(searchDecVal[1])) {
            value = searchDecVal[0];
          }
        }

        window.searchSortActive = value.trim().length > 0;

        if (
          (item.status + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.type + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.subdivision + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.workStartMp + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.workEndMp + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.controlNumber === 0 ? "--" : item.controlNumber) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.controlNumber ? "--" : "GR" + item.syncId) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.tracks.length > 1 ? "*Multiple*" : item.tracks[0]) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (recentIssueTime + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.fromLocation + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.toLocation + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      });
    } else {
      dataSet = dataSet.filter(function (item) {
        var effectiveTimeFormat = item.effectiveTime
          ? moment(item.effectiveTime).format("ddd MM/DD/YY HH:mm") +
            item.effectiveTimezone
          : "";
        var workStartDate = item.workStartDate
          ? moment(item.workStartDate).format("ddd HH:mm")+item.restrictionTimeZone+" "+moment(item.workStartDate).format("MM/DD/YY")
          : "";
        var workEndDate = item.workEndDate
          ? moment(item.workEndDate).format("ddd HH:mm")+item.restrictionTimeZone+" "+moment(item.workStartDate).format("MM/DD/YY")
          : "";
        var issueTime = item.issueTime
          ? moment(item.issueTime).format("HH:mm MM/DD")
          : "None";
        var recentIssueTime = item.issueTime
          ? moment(item.issueTime).format("MM/DD/YY HH:mm")
          : "";
        let estimatedRemovalDate = item.estimatedRemovalDate
          ? moment(item.estimatedRemovalDate).format("MM/DD/YY")
          : "";

        let textSearch = "";
        if (item.comments) {
          if (item.comments.length > 0) {
            textSearch = item.comments[0];
          }
        }

        let searchDecVal = value.trim().split(".");

        if (searchDecVal.length === 2) {
          if (/^0*$/.test(searchDecVal[1])) {
            value = searchDecVal[0];
          }
        }

        window.searchSortActive = value.trim().length > 0;

        if (
          (item.aReasonDescription + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.workEndMp + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.status + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.type + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.subdivision + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.foremanName + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.dsInits + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.workStartMp + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.passengerSpeed + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.freightSpeed + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.controlNumber === 0 ? "--" : item.controlNumber) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.controlNumber ? "--" : "GR" + item.syncId) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          ((item.tracks.length > 1 ? "*Multiple*" : item.tracks[0]) + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (workStartDate + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (workEndDate + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (issueTime + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (recentIssueTime + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.authorizedBy + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.fromLocation + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (item.toLocation + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (textSearch + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (estimatedRemovalDate + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1 ||
          (effectiveTimeFormat + "")
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      });
    }
    dataForIssuedTab = dataSet;
    this.setState({ filteredData: dataForIssuedTab });
  },

  _onRowClick: function (data) {
    //TODO: Create separate clicks for A,B Issued list and A,B Request list
    var rowData = data,
      props = this.props;
    var userData = props.userRoles;
    if (
      this.props.gridType === "issuedFormA" ||
      this.props.gridType === "issuedFormB" ||
      this.props.gridType === "requestFormA" ||
      this.props.gridType === "requestFormB" ||
      this.props.gridType === "issuedFormC" ||
      this.props.gridType === "issuedTCM"
    ) {
      rowData = data.rowData;
    }
    if (this.props.isDirty) {
      window
        .confirm("Confirm Opening", {
          description:
            "Viewing this item will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "View",
          abortLabel: "Go Back",
        })
        .then(function () {
          if (
            userData != null &&
            userData.indexOf(Constants.Roles.DISPATCHER) > -1
          ) {
            //If a dispatcher or higher is opening a request, do not update guids
            openRequest(props, rowData);
          } else {
            open(props, rowData);
          }
        });
    } else {
      if (
        userData != null &&
        userData.indexOf(Constants.Roles.DISPATCHER) > -1
      ) {
        //If a dispatcher or higher is opening a request, do not update guids
        openRequest(props, rowData);
      } else {
        open(props, rowData);
      }
    }
  },

  _onFormCRowClick: function (data) {
    openFormC(data.rowData);
  },
  _onTCMRowClick: function (data) {
    openTCM(data.rowData);
  },

  render: function () {
    const { rowHeight, headerHeight, overscanRowCount, sortBy, sortDirection } =
      this.state;

    var gridForm = "";
    if (screen.height <= 768) {
      var hig = "67vh";
    } else {
      var hig = "81vh";
    }

    if (this.state.previousSub !== this.props.selectedSub) {
      ifDataModified = false;
      this.state.previousSub = this.props.selectedSub;
    }
    if (this.props.loading) {
      ifDataModified = false;
    }

    if (ifDataModified === false) {
      //For the Recent Tab, check if there is a sort. Resort if it exists
      if (
        this.props.gridType === "recentIssued" &&
        this.state.recentSortBy !== null
      ) {
        dataForIssuedTab = recentSort(
          this.props.data,
          this.state.recentSortBy,
          this.state.recentSortDirection
        );
      } else {
        dataForIssuedTab = this.props.data;
      }
    }
    var list = dataForIssuedTab;
    let displayMsg = "";
    if (this.props.messages.length !== 0) {
      let message = this.props.messages[0];

      let style = "restrictionListErrorItem";

      switch (message.type) {
        case 'info':
          style = "restrictionListInfoItem";
          break;
        case 'warning':
          style = "restrictionListWarningItem";
          break;
      }
      
      displayMsg = (
        <label className={style}>
          {message.message}
        </label>
      );
    }

    var searchBox = (
      <div id="accordion" className="ui-widget-HistoryTableHeader">
        {displayMsg}
        <span>
          <b> Search: </b>
        </span>
        <input
          type="text"
          className="searchId"
          onChange={(event) =>
            this._filterRecordsOfTheTable(event.target.value)
          }
        />
      </div>
    );

    if (this.props.gridType === "issuedFormA") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}

          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.3}
                      label="Subdivision"
                      dataKey="subdivision"
                    />
                    <Column
                      width={width * 0.21}
                      label="Rstrn#"
                      dataKey="controlNumber"
                    />
                    <Column
                      width={width * 0.26}
                      label="From MP"
                      dataKey="workStartMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.21}
                      label="End MP"
                      dataKey="workEndMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.28}
                      label="Psgr Speed"
                      dataKey="passengerSpeed"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Frt Speed"
                      dataKey="freightSpeed"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Tracks"
                      dataKey="tracks"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="Effective Date Time"
                      dataKey="effectiveTime"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Reason"
                      dataKey="aReasonDescription"
                    />
                    <Column
                      width={width * 0.4}
                      label="Issued Time"
                      dataKey="issueTime"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Issued By"
                      dataKey="dsInits"
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "issuedFormB") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.33}
                      label="Subdivision"
                      dataKey="subdivision"
                    />
                    <Column
                      width={width * 0.21}
                      label="Rstrn#"
                      dataKey="controlNumber"
                    />
                    <Column
                      width={width * 0.26}
                      label="From MP"
                      dataKey="workStartMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.24}
                      label="End MP"
                      dataKey="workEndMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="From Date"
                      dataKey="workStartDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="To Date"
                      dataKey="workEndDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Foreman"
                      dataKey="foremanName"
                      cellRenderer={this.formatValue}
                    />
                    <Column width={width * 0.21} label="DS" dataKey="dsInits" />
                    <Column
                      width={width * 0.4}
                      label="Tracks"
                      dataKey="tracks"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Eff Ts"
                      dataKey="issueTime"
                      cellRenderer={this.formatValue}
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "issuedFormC") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onFormCRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.15}
                      label="Subdivision"
                      dataKey="subdivision"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.15}
                      label="Rstrn#"
                      dataKey="controlNumber"
                    />
                    <Column
                      width={width * 0.2}
                      label="From"
                      dataKey="formCFrom"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="To"
                      dataKey="formCTo"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.6}
                      label="Text"
                      dataKey="formCComments"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.1}
                      label="Est Removal"
                      dataKey="estimatedRemovalDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.15}
                      label="Authorized By"
                      dataKey="authorizedBy"
                    />
                    <Column
                      width={width * 0.2}
                      label="Issued Time"
                      dataKey="issueTime"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Issued By"
                      dataKey="dsInits"
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "requestFormA") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.22}
                      label="Subdivision"
                      dataKey="subdivision"
                    />
                    <Column
                      width={width * 0.15}
                      label="Grit Id"
                      dataKey="syncId"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.18}
                      label="From MP"
                      dataKey="workStartMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.16}
                      label="End MP"
                      dataKey="workEndMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.22}
                      label="Psgr Speed"
                      dataKey="passengerSpeed"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="Frt Speed"
                      dataKey="freightSpeed"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="Tracks"
                      dataKey="tracks"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.3}
                      label="Eff Date Time"
                      dataKey="effectiveTime"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.24}
                      label="Reason"
                      dataKey="aReasonDescription"
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "requestFormB") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.25}
                      label="Subdivision"
                      dataKey="subdivision"
                    />
                    <Column
                      width={width * 0.2}
                      label="GRIT Id"
                      dataKey="syncId"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="From MP"
                      dataKey="workStartMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="End MP"
                      dataKey="workEndMp"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.3}
                      label="From Date"
                      dataKey="workStartDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.3}
                      label="To Date"
                      dataKey="workEndDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Foreman"
                      dataKey="foremanName"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.1}
                      label="Stp"
                      dataKey="stopsTraffic"
                    />
                    <Column
                      width={width * 0.25}
                      label="Tracks"
                      dataKey="tracks"
                      cellRenderer={this.formatValue}
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "issuedTCM") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onTCMRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.21}
                      label="Rstrn#"
                      dataKey="controlNumber"
                    />
                    <Column
                      width={width * 0.26}
                      label="From"
                      dataKey="TCMFrom"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.24}
                      label="To"
                      dataKey="TCMTo"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="Text"
                      dataKey="TCMComments"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="Est Removal"
                      dataKey="estimatedRemovalDate"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Authorized By"
                      dataKey="authorizedBy"
                    />
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter">
            {" "}
          </div>
        </div>
      );
    } else if (this.props.gridType === "recentIssued") {
      gridForm = (
        <div style={{ height: "100%" }}>
          {searchBox}
          <ContentBox className="currentSchematic">
            <div style={{ height: hig }}>
              <AutoSizer>
                {({ height, width }) => (
                  <Table
                    ref="Table"
                    disableHeader={false}
                    headerClassName="historyheaderColumn"
                    width={width}
                    height={height}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    overscanRowCount={overscanRowCount}
                    rowCount={list.length}
                    rowClassName={this._rowClassName}
                    sort={this._recentSort}
                    sortBy={this.state.recentSortBy}
                    sortDirection={this.state.recentSortDirection}
                    noRowsRenderer={this._noRowsRenderer}
                    onRowDoubleClick={this._onRowClick}
                    rowGetter={({ index }) => list[index]}
                  >
                    <Column
                      width={width * 0.1}
                      label="Subdivision"
                      dataKey="subdivision"
                      cellRenderer={this.formatValue}
                    />
                    <Column width={width * 0.1} label="Type" dataKey="type" />
                    <Column
                      width={width * 0.21}
                      label="Rstrn#"
                      dataKey="controlNumber"
                    />
                    <Column
                      width={width * 0.1}
                      label="Status"
                      dataKey="status"
                    />
                    <Column
                      width={width * 0.2}
                      label="From"
                      dataKey="formCFrom"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.2}
                      label="To"
                      dataKey="formCTo"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.4}
                      label="Tracks"
                      dataKey="tracks"
                      cellRenderer={this.formatValue}
                    />
                    <Column
                      width={width * 0.25}
                      label="Issued Ts"
                      dataKey="recentIssueTime"
                      cellRenderer={this.formatValue}
                    />
                    {/*<Column width={width * .25} label='Eff Ts' dataKey='effectiveTime' cellRenderer={this.formatValue}/>*/}
                  </Table>
                )}
              </AutoSizer>
            </div>
          </ContentBox>
          <div id="accordion" className="ui-widget-TableFooter"></div>
        </div>
      );
    }

    return <div style={{ height: "100%" }}>{gridForm}</div>;
  },
});

function formatMp(mp) {
  var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);

  if (mpRegexNoDecimal.test(mp)) {
    return mp + ".0";
  }
  return mp;
}

function renderTracks(value) {
  if (!Array.isArray(value)) return "";
  if (value.length > 1) {
    return <span title={value.join("\n")}>*Multiple*</span>;
  } else {
    return <span>{value[0]}</span>;
  }
}

function renderDataWithPopover(comments) {
  if (comments && comments.length > 0) {
    // comments = comments.sort(function (a, b) {
    //   return a.lineNumber - b.lineNumber;
    // });
    //
    // let formCTextLines = comments.map(function (tr) {
    //   return tr.comment;
    // });

    let textLength = comments.length;

    if (textLength > 30) {
      //Cap the display at 30 lines
      textLength = 30;
    }

    let text = comments.join("\n");

    const popover = (
      <Popover id="popover-basic" title="FULL FORM C TEXT">
        <textarea
          id="formCPopOverText"
          rows={textLength}
          cols={Constants.MaxValues.MAX_COMMENT_LINE_LENGTH}
          value={text}
          disabled={true}
        />
      </Popover>
    );

    return (
      <OverlayTrigger placement="left" overlay={popover}>
        <span>{comments[0]}</span>
      </OverlayTrigger>
    );
  }
}

function renderTCMDataWithPopover(comments) {
  if (comments && comments.length > 0) {
    // comments = comments.sort(function (a, b) {
    //   return a.lineNumber - b.lineNumber;
    // });
    //
    // let TCMTextLines = comments.map(function (tr) {
    //   return tr.comment;
    // });

    let textLength = comments.length;

    if (textLength > 30) {
      //Cap the display at 30 lines
      textLength = 30;
    }

    let text = comments.join("\n");

    const popover = (
      <Popover id="popover-basic" title="FULL TCM TEXT">
        <textarea
          id="tcmPopOverText"
          rows={textLength}
          cols={Constants.MaxValues.MAX_TCM_LINE_LENGTH}
          value={text}
          disabled={true}
        />
      </Popover>
    );

    return (
      <OverlayTrigger placement="right" overlay={popover}>
        <span>{comments[0]}</span>
      </OverlayTrigger>
    );
  }
}

function renderMultiSubHover(subs) {
  if (subs && subs.length > 0) {
    const popover = (
      <Popover id="popover-subs">
        <table>
          <tbody>
            {subs.map((val, i) => (
              <tr key={i}>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Popover>
    );

    return (
      <OverlayTrigger placement="right" overlay={popover}>
        <span>MULTI</span>
      </OverlayTrigger>
    );
  }
}

function issuedTimeSort(a, b, sortDirection) {
  if (sortDirection === "ASC") {
    return moment(a.issueTime).isAfter(moment(b.issueTime)) ? 1 : -1;
  } else if (sortDirection === "DESC") {
    return moment(a.issueTime).isBefore(moment(b.issueTime)) ? 1 : -1;
  }
}

function recentSort(items, sortBy, sortDirection) {
  const comparer = (a, b) => {
    if (sortBy === "tracks") {
      const track1 =
        a["tracks"].length > 1 ? "*Multiple*" : a["tracks"][0] || ""; //Form Cs don't have track so convert undefined to ""
      const track2 =
        b["tracks"].length > 1 ? "*Multiple*" : b["tracks"][0] || "";
      if (sortDirection === "ASC") {
        if (track1 === track2) {
          return issuedTimeSort(a, b, "ASC");
        } else return track1 > track2 ? 1 : -1;
      } else if (sortDirection === "DESC") {
        if (track1 === track2) {
          return issuedTimeSort(a, b, "ASC");
        } else return track1 < track2 ? 1 : -1;
      }
    } else if (sortBy === "recentIssueTime") {
      if (sortDirection === "ASC") {
        return issuedTimeSort(a, b, "ASC");
      } else if (sortDirection === "DESC") {
        return issuedTimeSort(a, b, "DESC");
      }
    } else if (sortBy === "type") {
      const type1 = a.type;
      const type2 = b.type;
      if (sortDirection === "ASC") {
        if (type1 === type2) {
          return issuedTimeSort(a, b, "ASC");
        } else return type1 > type2 ? 1 : -1;
      } else if (sortDirection === "DESC") {
        if (type1 === type2) {
          return issuedTimeSort(a, b, "ASC");
        } else return type1 < type2 ? 1 : -1;
      }
    } else if (sortBy === "status") {
      const status1 = a.status;
      const status2 = b.status;
      if (sortDirection === "ASC") {
        if (status1 === status2) {
          return issuedTimeSort(a, b, "ASC");
        } else return status1 > status2 ? 1 : -1;
      } else if (sortDirection === "DESC") {
        if (status1 === status2) {
          return issuedTimeSort(a, b, "ASC");
        } else return status1 < status2 ? 1 : -1;
      }
    } else if (sortBy === "effectiveTime") {
      if (sortDirection === "ASC") {
        return moment(a.effectiveTime).isAfter(moment(b.effectiveTime))
          ? 1
          : -1;
      } else if (sortDirection === "DESC") {
        return moment(a.effectiveTime).isBefore(moment(b.effectiveTime))
          ? 1
          : -1;
      }
    } else if (sortBy === "formCFrom") {
      //From/To can be milepost, location or none
      let mp1 = a.workStartMp;
      if (mp1 === -1) {
        mp1 = 10000; //This should be sorted after the MPs so set it to a value that is higher than the mp max
      }

      let mp2 = b.workStartMp;
      if (mp2 === -1) {
        mp2 = 10000;
      }

      //Sort mileposts first, then locations (including blanks)
      if (mp1 === mp2) {
        if (mp1 === 10000) {
          //They are both locations so sort by the locations
          if (sortDirection === "ASC") {
            return a.fromLocation === b.fromLocation
              ? 0
              : a.fromLocation > b.fromLocation
              ? 1
              : -1;
          }
          if (sortDirection === "DESC") {
            return a.fromLocation === b.fromLocation
              ? 0
              : a.fromLocation < b.fromLocation
              ? 1
              : -1;
          }
        } else return 0; //They are equal actual mps
      } else {
        if (sortDirection === "ASC") {
          return mp1 > mp2 ? 1 : -1;
        }
        if (sortDirection === "DESC") {
          return mp1 < mp2 ? 1 : -1;
        }
      }
    } else if (sortBy === "formCTo") {
      //From/To can be milepost, location or none
      let mp1 = a.workEndMp;
      if (mp1 === -1) {
        mp1 = 10000; //This should be sorted after the MPs so set it to a value that is higher than the mp max
      }

      let mp2 = b.workEndMp;
      if (mp2 === -1) {
        mp2 = 10000;
      }

      //Sort mileposts first, then locations (including blanks)
      if (mp1 === mp2) {
        if (mp1 === 10000) {
          //They are both locations so sort by the locations
          if (sortDirection === "ASC") {
            return a.toLocation === b.toLocation
              ? 0
              : a.toLocation > b.toLocation
              ? 1
              : -1;
          }
          if (sortDirection === "DESC") {
            return a.toLocation === b.toLocation
              ? 0
              : a.toLocation < b.toLocation
              ? 1
              : -1;
          }
        } else return 0; //They are equal actual mps
      } else {
        if (sortDirection === "ASC") {
          return mp1 > mp2 ? 1 : -1;
        }
        if (sortDirection === "DESC") {
          return mp1 < mp2 ? 1 : -1;
        }
      }
    } else {
      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    }
  };

  return items.sort(comparer);
}

const isValidDt = (dt) => moment(dt).isValid();

const getDt = (dt) =>
    isValidDt(dt) ? moment(dt).format("ddd MM/DD/YY HH:mm") : "";

const getDtRecent = (dt, tz) =>
    isValidDt(dt) ? moment(dt).format("MM/DD/YY HH:mm") : "";

